































































// decoradores
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Banco } from "@/typings/store/plugins/easyFirestore/bancos";
import SVGIcon from "@/components/SVGIcon.vue";
// tipos

// tipos
@Component({
  components: {
    SVGIcon,
  },
})
export default class InfoBanco extends Vue {
  @Prop() readonly banco!: Banco;
  @Prop({ type: Boolean }) readonly showTitulo!: boolean;

  get id(): string {
    return this.banco.id || "N/R";
  }

  get nombre(): string {
    return this.banco.nombre || "N/R";
  }

  get posicion(): string {
    return this.banco.posicion || "N/R";
  }


  @Emit("cerrar")
  onCerrar(): void {
    return;
  }
}
